import PropTypes from "prop-types";

import Title from "components/atoms/Title";

const Component = ({ className, data }) => {
  return (
    <div className={className}>
      <div className="container">
        <Title
          text={data.title}
          as="h4"
          className=" mb-6 text-center text-3xl font-semibold text-bbc-brand-800 lg:mb-10 lg:text-4xl"
        />
        <div className="row">
          <div className="col-12 lg:col-5">
            <div className="shadow-bbc mb-6 overflow-hidden rounded-2xl bg-white lg:mb-10">
              <div>
                <p className="border-b border-[#E5E5E5] p-3 text-center font-medium text-bbc-brand-700">
                  {data.dataPrice1.title}
                </p>
              </div>
              <div>
                {data.dataPrice1.ListItem &&
                  data.dataPrice1.ListItem.length > 0 &&
                  data.dataPrice1.ListItem.map((item, index) => (
                    <div
                      key={index}
                      className="flex px-4 py-3 odd:bg-white even:bg-bbc-brand-100"
                    >
                      <div className="w-9/12 pr-2">
                        <div
                          className="mb-1 text-sm font-medium text-bbc-gray"
                          dangerouslySetInnerHTML={{ __html: item.titleItem }}
                        ></div>
                        {item.description && (
                          <div
                            className="text-sm font-normal italic "
                            style={{ color: "#7c7b7b" }}
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          ></div>
                        )}
                      </div>
                      <div className="grow self-center text-sm text-bbc-brand-500">
                        <p className="text-right">US${item.price}</p>
                        {item.time && <p className="text-right">{item.time}</p>}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="shadow-bbc mb-6 overflow-hidden rounded-2xl bg-white lg:mb-0">
              <div>
                <p className="border-b border-[#E5E5E5] p-3 text-center font-medium text-bbc-brand-700">
                  {data.dataPrice2.title}
                </p>
              </div>
              <div>
                {data.dataPrice2.ListItem &&
                  data.dataPrice2.ListItem.length > 0 &&
                  data.dataPrice2.ListItem.map((item, index) => (
                    <div
                      key={index}
                      className="flex px-4 py-3 odd:bg-white even:bg-bbc-brand-100"
                    >
                      <div className="w-9/12 pr-2">
                        <div
                          dangerouslySetInnerHTML={{ __html: item.titleItem }}
                          className="mb-1 text-sm font-medium text-bbc-gray"
                        ></div>
                        {item.description && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                            className="text-sm font-normal italic "
                            style={{ color: "#7c7b7b" }}
                          ></div>
                        )}
                      </div>
                      <div className="grow self-center text-sm text-bbc-brand-500">
                        <p className="text-right">US${item.price}</p>
                        {item.time && <p className="text-right">{item.time}</p>}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div className="col-12 lg:col-7">
            <div className="shadow-bbc overflow-hidden rounded-2xl bg-white">
              <div>
                <p className="border-b border-[#E5E5E5] p-3 text-center font-medium text-bbc-brand-700">
                  {data.dataPrice3.title}
                </p>
              </div>
              <div>
                {data.dataPrice3.ListItem &&
                  data.dataPrice3.ListItem.length > 0 &&
                  data.dataPrice3.ListItem.map((item, index) => (
                    <div
                      key={index}
                      className="flex px-4 py-3 odd:bg-white even:bg-bbc-brand-100"
                    >
                      <div className="w-9/12 pr-2">
                        <div
                          dangerouslySetInnerHTML={{ __html: item.titleItem }}
                          className="mb-1 text-sm font-medium text-bbc-gray"
                        ></div>
                        {item.description && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                            className="text-sm font-normal italic "
                            style={{ color: "#7c7b7b" }}
                          ></div>
                        )}
                      </div>
                      <div className="grow self-center text-sm text-bbc-brand-500">
                        <p className="text-right">US${item.price}</p>
                        {item.time && <p className="text-right">{item.time}</p>}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Component;

Component.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
};

Component.defaultProps = {
  className: "",
};
